module.exports = require('./helpers/bundle-url').getBundleURL('7Zmw1') + "logo-dark.eefe0b7f.svg";